import { alpha, Dialog, styled } from '@mui/material';
import { chromeYellow, sanguine, spaceCadet } from '../../../../../../../../../../../utils/colors';

const StyledDialog = styled(Dialog)({
  '& > div > .MuiPaper-root': {
    maxHeight: 600,
    minHeight: 600,
  },
  '& .MuiDialogTitle-root': {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
  },
  '& .MuiDialogContent-root': {
    '&.isLoading': {
      opacity: 0.9,
      color: 'red',
    },
    display: 'flex',
    flexDirection: 'column',
    gap: 16,
    '& > .MuiBox-root': {
      display: 'flex',
      flexDirection: 'column',
      gap: 2,
      '& > .MuiFormControlLabel-root': {
        marginLeft: 0,
        gap: 4,
        '.MuiTypography-body1': {
          fontSize: 14,
        },

      },
      '& > .MuiTypography-body1': {
        fontSize: 14,
        fontWeight: 600,
      },
    },
    '& > .MuiTableContainer-root': {
      '&.isLoading': {
        opacity: 0.5,
      },
      '& .MuiTableCell-root': {
        border: `1px solid ${alpha(spaceCadet[400], 0.2)}`,
      },
      '& .MuiTableHead-root': {
        '& .MuiTableCell-root': {
          fontWeight: 600,
        },
      },
      '& .MuiTableRow-root': {
        '&.total-row': {
          fontWeight: 600,
          color: spaceCadet[400],
          backgroundColor: alpha(spaceCadet[400], 0.1),
          '&.overall': {
            '& .MuiTableCell-root': {
              fontWeight: 700,
              borderTop: `2px solid ${alpha(spaceCadet[500], 1)}`,
            },
          },
        },
        '.Critical': {
          borderColor: alpha(sanguine[600], 0.5),
          backgroundColor: alpha(sanguine[600], 0.1),
        },
        '.Major': {
          borderColor: alpha(chromeYellow[500], 0.5),
          backgroundColor: alpha(chromeYellow[500], 0.1),
        },
      },
    },
  },
  '& > .MuiDialogActions-root': {
    padding: '16px',
  },
});

export default StyledDialog;
